<template>
  <div id="sidebar" class="sidebar">
    <div class="title">
      {{ title }}
    </div>

    <slot name="actionTop"></slot>

    <div id="app-sidebar-list" class="list">
      <router-link
        class="list__item"
        :class="{ list__item_selected: item.selected }"
        v-for="item in routerItems"
        :key="item.id"
        :to="item.url"
      >
        {{ item.name }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppSidebar",
  props: {
    title: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    loading: Boolean
  },
  data() {
    return {
      loader: undefined,
      count: 25,
      routerItems: [],
      loadingData: false,
      scrollId: undefined
    };
  },
  computed: {
    disabled() {
      return this.loadingData;
    }
  },
  methods: {
    checkLoading() {
      if (this.loader) {
        this.loader.close();
        this.loader = undefined;
      }

      if (this.loading) {
        this.loader = this.$loading({
          target: document.getElementById("sidebar"),
          lock: true,
          spinner: "el-icon-loading",
          fullscreen: false
        });
      }
    },
    initRouterList() {
      this.routerItems = this.items.slice(0, this.count);
      this.loadingData = false;
    },
    append() {
      let curLen = this.routerItems.length;
      let newLen = Math.min(curLen + this.count, this.items.length);
      if (newLen > curLen) {
        for (let i = curLen; i < newLen; i++) {
          this.routerItems.push(this.items[i]);
        }
      }
    },
    handleScroll(el) {
      if (
        el.target.scrollTop + el.target.clientHeight >=
        el.target.scrollHeight
      ) {
        if (this.routerItems.length < this.items.length) {
          this.append();
        }
      }
    },
    init() {
      this.scrollId = document.getElementById("app-sidebar-list");
      this.scrollId.addEventListener("scroll", this.handleScroll);
    }
  },
  mounted() {
    setTimeout(this.init, 1000);
    this.initRouterList();
  },
  beforeDestroy() {
    this.scrollId.removeEventListener("scroll", this.handleScroll);
    this.scrollId = undefined;
  },
  watch: {
    loading: function () {
      this.checkLoading();
    },
    items: function () {
      this.initRouterList();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/css/variables.scss";

.sidebar {
  padding: 5px;
  height: 100%;
  box-sizing: border-box;

  .title {
    font-weight: 600;
    padding: 5px 0;
    border-bottom: 2px solid $company_color;
    box-sizing: border-box;
  }

  .list {
    font-size: 14px;
    color: $company_color;
    overflow-x: hidden;
    overflow-y: auto;
    height: calc(100% - 74px);
    box-sizing: border-box;

    .list__item {
      display: block;
      padding: 10px 3px;
      text-decoration: none;
    }

    .list__item:hover {
      cursor: pointer;
      border-right: 2px solid $company_color;
    }

    .list__item_selected {
      background-color: $company_color;
      color: $main_background_color;
    }
  }
}
</style>
